import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import MembersSettingsPopUp from "./MembersSettingsPopUp";

const ViewMembers = ({
  setViewMembersPopUp,
  activeChat,
  setActiveChat,
  activeChatRef,
  emitWithAck,
  setListOfMessagesAndInfo,
  setChats,
}) => {
  const [selectedValues, SetSelectedValues] = useState(
    Array(activeChat.participants.length + 1).fill(null),
  );
  const { userId, userInfo } = useAuth();
  const [membersSettingsPopUp, setMembersSettingsPopUp] = useState(null);
  const isAdmin = activeChat.admin.includes(String(userId));

  const filteredMembers = [
    { _id: userId, username: userInfo.username, email: userInfo.email },
    ...activeChat.participants,
  ];
  return (
    <>
      <div
        onClick={(e) => {
          setViewMembersPopUp(false);
          e.stopPropagation();
        }}
        className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center"
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="w-[70dvw] h-[80dvh] bg-white rounded-lg p-4"
        >
          {filteredMembers.map((participant, index) => {
            const isDisabled = !isAdmin;
            return (
              <div
                key={participant._id}
                className="flex justify-between items-center hover:bg-gray-300"
              >
                <div>
                  {participant.username +
                    (String(participant._id) === String(userId) ? "(you)" : "")}
                </div>
                <div className="flex justify-evenly gap-1">
                  <div className="bg-gray-200 p-1 border border-gray-300 rounded-lg">
                    <select
                      disabled={isDisabled}
                      className={`${isDisabled ? "cursor-not-allowed" : ""}`}
                      value={
                        selectedValues[index] ||
                        (activeChat.admin.includes(String(participant._id))
                          ? "Admin"
                          : "Member")
                      }
                      onChange={(e) => {
                        setMembersSettingsPopUp((prev) => {
                          if (
                            activeChat.admin.length === 1 &&
                            e.target.value === "Member"
                          ) {
                            return {
                              type: "status",
                              value: "zero admin problem",
                            };
                          }
                          return {
                            type: "status",
                            _id: participant._id,
                            username: participant.username,
                            email: participant.email,
                            value: e.target.value,
                            groupId: activeChat._id,
                            index: index,
                          };
                        });
                      }}
                    >
                      <option value={"Admin"}>Admin</option>
                      <option value={"Member"}>Member</option>
                    </select>
                  </div>
                  {String(participant._id) !== String(userId) && (
                    <div>
                      <button
                        onClick={() => {
                          setMembersSettingsPopUp({
                            type: "remove",
                            _id: participant._id,
                            username: participant.username,
                            email: participant.email,
                            groupId: activeChat._id,
                          });
                        }}
                        className={`${
                          isDisabled ? "cursor-not-allowed" : ""
                        } bg-red-400 border-red-700 p-1 rounded-lg`}
                        disabled={isDisabled}
                      >
                        Remove
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {membersSettingsPopUp && (
        <MembersSettingsPopUp
          membersSettingsPopUp={membersSettingsPopUp}
          setMembersSettingsPopUp={setMembersSettingsPopUp}
          setActiveChat={setActiveChat}
          activeChatRef={activeChatRef}
          emitWithAck={emitWithAck}
          setListOfMessagesAndInfo={setListOfMessagesAndInfo}
          setChats={setChats}
          SetSelectedValues={SetSelectedValues}
        />
      )}
    </>
  );
};

export default ViewMembers;
